import { loadPdfjs } from "@/lib/pdfjs";

const MAX_CHARS = 400_000;
const MIN_LETTER_COUNT = 40;

export type PdfTextItem = { str?: string };

/** pdf.js `getTextContent` itemek → sima szöveg. */
export function joinPdfTextItems(items: ReadonlyArray<PdfTextItem>): string {
  const parts: string[] = [];
  for (const item of items) {
    const s = item.str?.replace(/\s+/g, " ").trim();
    if (s) parts.push(s);
  }
  return parts.join(" ").replace(/[ \t]+\n/g, "\n").trim();
}

/** Szkennelt / üres PDF: nincs elég betű vagy szám. */
export function isExtractedTextEmpty(text: string): boolean {
  const letters = text.replace(/[^\p{L}\p{N}]+/gu, "");
  return letters.length < MIN_LETTER_COUNT;
}

export function isPdfUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  const path = url.split("?")[0] ?? "";
  return /\.pdf$/i.test(path);
}

export function isPdfFile(file: { name: string; type?: string }): boolean {
  if (file.type === "application/pdf") return true;
  return /\.pdf$/i.test(file.name);
}

/**
 * Nyilvános URL-ről kinyeri a PDF teljes szövegét.
 * Üres / képalapú PDF-nél rövid vagy üres stringet ad (lásd `isExtractedTextEmpty`).
 */
export async function extractPdfTextFromUrl(url: string): Promise<string> {
  const pdfjs = await loadPdfjs();
  const loadingTask = pdfjs.getDocument({ url, disableAutoFetch: false });
  const doc = await loadingTask.promise;
  try {
    const pages: string[] = [];
    let total = 0;
    for (let i = 1; i <= doc.numPages; i += 1) {
      const page = await doc.getPage(i);
      const content = await page.getTextContent();
      const text = joinPdfTextItems(content.items as PdfTextItem[]);
      if (text) {
        pages.push(text);
        total += text.length;
      }
      if (total >= MAX_CHARS) break;
    }
    return pages.join("\n\n").slice(0, MAX_CHARS);
  } finally {
    void loadingTask.destroy();
  }
}
